import { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import Async from 'react-select/async';

import Modal from '../Modal';
import { API } from '../../API';
import { showRequestError } from '../../utils/requestError';
import { toast } from 'react-toastify';
import './index.css';

export default function CopyGroupToWorkspacePopup({ isVisible, onClose, groupId }) {
  const { t } = useTranslation();
  const [workspace, setWorkspace] = useState(null);
  const [workspaces, setWorkspaces] = useState([]);

  useEffect(() => {
    if (isVisible) {
        API.fetch('GET', `/API/v1/workspaces?size=100`).then((data) => {
            setWorkspaces(data.objects);
        }).catch((error) => showRequestError(error, t('Workspaces')));
    }
  }, [isVisible]);

  const getWorkspaces = (inputValue, callback) => {
    return API.fetch('GET', `/API/v1/workspaces?q=${inputValue}`).then((data) => {
      callback(
        data.objects
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .map((workspace) => {
            return { value: workspace.id, label: workspace.name };
          }),
      );
    }).catch((error) => {
      showRequestError(error, t('Workspaces'));
      callback([]);
    });
  }
  
  let workspacesPromiseTimeout;
  const promiseOptions = function (inputValue) {
    if (workspacesPromiseTimeout !== null) {
      clearTimeout(workspacesPromiseTimeout);
    }

    if (! inputValue) {
        return [];
    }

    return new Promise((resolve) => {
      workspacesPromiseTimeout = setTimeout(() => {
        getWorkspaces(inputValue, resolve);
      }, 1000);
    });
  }

  const handleCopyGroup = (groupId, workspaceId) => {
    API.fetch('POST', `/API/v1/admin/groups/${groupId}/workspaces/${workspaceId}`, null, {}).then(() => {
        toast.success(t('Group copied to workspace'));
        onClose();
    }).catch((error) => showRequestError(error, t('Copy group')));
  };

  return (
    <Modal
        isVisible={isVisible}
        doNotCloseOnOutsideClick={true}
        title={t('Copy a group to another workspace')}
        content={
            <div className='copy-group-wrapper'>
                <div>
                    {t('Are you sure you want to copy these sources from a group?')}
                </div>
                <Async
                  cacheOptions
                  defaultOptions={workspaces.map(i => ({value: i.id, label: i.name}))}
                  onChange={(value) => setWorkspace(value)}
                  classNamePrefix="copy-group-modal"
                  value={workspace}
                  loadOptions={promiseOptions}
                  placeholder={t('Please enter at least 1 symbol to search')}
                  noOptionsMessage={() => t('Please enter at least 1 symbol')}
                  loadingMessage={() => t('Loading...')}
                />
              </div>
        }
        footer={
          <>
            <button
              className="new-button"
              disabled={!workspace}
              onClick={() =>
                handleCopyGroup(groupId, workspace.value)
              }
            >
              {t('Copy')}
            </button>
            <button
              className="btn-reset"
              onClick={onClose}
            >
              {t('Cancel')}
            </button>
          </>
        }
        onClose={onClose}
      />
  );
}
